import homepageReducer from "./homepage/homepageSlice";
import planpageReducer from "./planpage/planpageSlice";
import rootStrapiSlice from "./strapi/rootStrapiSlice";
import checkoutReducer from "./checkout/checkoutSlice";
import internationalServices from "./internationalService/internationalServiceSlice";
import trackorderSlice from "./trackorder/trackorderSlice";
import billCalculatorSlice from "./billCalculator/billCalculatorSlice";
import activationSlice from "./activation/activationSlice";
import customerSlice from "./customer/customerSlice";
import profileDetailsSlice from "./profile/profileSlice";
import accountSlice from "./account/accountSlice";
import billingSlice from "./billing/billingSlice";
import settingsSlice from "./settings/settingsSlice";
import servicesSlice from "./services/servicesSlice";
import walletSlice from "./wallet/walletSlice";
import shopWareSlice from "./shopWare/shopWareSlice";
import accountLockSlice from "./account-lock/accountLockSlice";

const rootSlice: any = {
  homepage: homepageReducer,
  strapi: rootStrapiSlice,
  planpage: planpageReducer,
  checkout: checkoutReducer,
  trackorder: trackorderSlice,
  internationalService: internationalServices,
  billCalculator: billCalculatorSlice,
  activation: activationSlice,
  customer: customerSlice,
  profileDetails: profileDetailsSlice,
  account: accountSlice,
  billing: billingSlice,
  settings: settingsSlice,
  services: servicesSlice,
  wallet: walletSlice,
  shopWare: shopWareSlice,
  accountLock: accountLockSlice,
};

export default rootSlice;
